// ★ Single source of truth for app version
// Update this value when bumping version — all components read from here
export const APP_VERSION = '3.9.14';
